<div class="cms-sidebar" [class.is-expanded]="expanded()">
  <div class="cms-sidebar__sections">
    <div class="cms-sidebar__section">
      @for (item of items; track item.id) {
        <span
          class="cms-sidebar__item-border"
          [class.is-selected]="isSelected(item.id)"
        >
          <button
            type="button"
            class="cms-sidebar__item"
            [class.is-selected]="isSelected(item.id)"
            (click)="navigate(item)"
            [attr.data-tooltip]="item.label"
          >
            <span class="cms-sidebar__icon-wrap" aria-hidden="true">
              <i class="pi cms-sidebar__icon" [ngClass]="item.icon"></i>
            </span>
            <span class="cms-sidebar__label">{{ item.label }}</span>
          </button>
        </span>
      }
    </div>
  </div>

  <div class="cms-sidebar__toggle">
    <button
      type="button"
      class="cms-sidebar__toggle-btn"
      (click)="toggleExpanded()"
    >
      <span class="sr-only">
        {{ expanded() ? 'Collapse sidebar' : 'Expand sidebar' }}
      </span>
      <svg viewBox="0 0 24 24" class="cms-sidebar__chevron" aria-hidden="true">
        <path
          d="M9 6l6 6-6 6"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    </button>
  </div>
</div>

